const scrollToTop = (): void => {
	if (typeof window === "undefined" || typeof document === "undefined") {
		return;
	}

	window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
};

export default scrollToTop;
